import { render, staticRenderFns } from "./vueCarousel.vue?vue&type=template&id=560f906a&"
import script from "./vueCarousel.vue?vue&type=script&lang=js&"
export * from "./vueCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports